import {
  Search, Globe, Zap, Eye, Mic, MousePointerClick, TrendingUp,
  Shield, BarChart3, FileText, Bot, Target, Download, GitCompare,
  BookOpen, PenLine, Activity, Languages,
} from "lucide-react";

export const SERVICE_DEFS = [
  { icon: Eye, nk: "s1", span: "md:col-span-8", hot: true, link: "/products/ai-visibility" },
  { icon: Search, nk: "s2", span: "md:col-span-4", link: "/products/seo-audit" },
  { icon: Globe, nk: "s3", span: "md:col-span-4", link: "/seo/en" },
  { icon: Mic, nk: "s4", span: "md:col-span-4", link: "/products/ai-visibility" },
  { icon: MousePointerClick, nk: "s5", span: "md:col-span-4", link: "/products/seo-audit" },
  { icon: GitCompare, nk: "s6", span: "md:col-span-6", link: "/products/competitor-spy" },
  { icon: FileText, nk: "s7", span: "md:col-span-6", link: "/products/blog-agent" },
  { icon: BookOpen, nk: "s8", span: "md:col-span-4", link: "/products/seo-audit" },
  { icon: PenLine, nk: "s9", span: "md:col-span-4", link: "/fix-my-seo" },
  { icon: Shield, nk: "s10", span: "md:col-span-4", link: "/products/seo-audit" },
  { icon: Zap, nk: "s11", span: "md:col-span-3", link: "/products/seo-audit" },
  { icon: BarChart3, nk: "s12", span: "md:col-span-3", link: "/products/seo-audit" },
  { icon: Activity, nk: "s13", span: "md:col-span-3", hot: true, link: "/products/seo-autopilot" },
  { icon: Download, nk: "s14", span: "md:col-span-3", link: "/products/seo-audit" },
  { icon: Bot, nk: "s15", span: "md:col-span-4", link: "/ai-simulator" },
  { icon: Target, nk: "s16", span: "md:col-span-4", link: "/attribution" },
  { icon: Languages, nk: "s17", span: "md:col-span-4", link: "/seo/sk" },
];

export const COMPARISON_KEYS = ["cmp_f1","cmp_f2","cmp_f3","cmp_f4","cmp_f5","cmp_f6","cmp_f7","cmp_f8","cmp_f9","cmp_f10","cmp_f11","cmp_f12"];

export const COMPARISON_DATA = [
  { us: true, ahrefs: false, semrush: false, yoast: false },
  { us: true, ahrefs: false, semrush: false, yoast: false },
  { us: true, ahrefs: false, semrush: false, yoast: false },
  { us: true, ahrefs: false, semrush: false, yoast: false },
  { us: true, ahrefs: true, semrush: true, yoast: "partial" },
  { us: true, ahrefs: true, semrush: true, yoast: false },
  { us: true, ahrefs: false, semrush: "paid", yoast: false },
  { us: true, ahrefs: false, semrush: false, yoast: false },
  { us: true, ahrefs: true, semrush: true, yoast: false },
  { us: true, ahrefs: false, semrush: "paid", yoast: false },
  { us: true, ahrefs: "paid", semrush: "paid", yoast: false },
  { us: true, ahrefs: false, semrush: "partial", yoast: false },
  { us: true, ahrefs: true, semrush: true, yoast: false },
];

export const DEFAULT_LANGUAGES = [
  { code: 'en', name: 'English (US)', flag: '🇺🇸' }, { code: 'en-gb', name: 'English (UK)', flag: '🇬🇧' },
  { code: 'sk', name: 'Slovenčina', flag: '🇸🇰' },
  { code: 'cs', name: 'Čeština', flag: '🇨🇿' }, { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' }, { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' }, { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' }, { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' }, { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
  { code: 'no', name: 'Norsk', flag: '🇳🇴' }, { code: 'da', name: 'Dansk', flag: '🇩🇰' },
  { code: 'fi', name: 'Suomi', flag: '🇫🇮' }, { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'bg', name: 'Български', flag: '🇧🇬' }, { code: 'hr', name: 'Hrvatski', flag: '🇭🇷' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦' }, { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' }, { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'zh', name: '中文', flag: '🇨🇳' }, { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' }, { code: 'id', name: 'Indonesia', flag: '🇮🇩' },
];
